<template>
  <Word
    v-bind="bindProps"
    :bgImg="require('@/assets/word_sausage.png')"
    :bgMask="require('@/assets/word_sausage_mask.svg')"
    v-on="$listeners"
    :class="$style.word"
  >
    {{ word.word }}
  </Word>
</template>

<script>
import wordMixin from '@/mixins/word'

export default {
  mixins: [wordMixin()],
}
</script>

<style lang="scss" module>
$width: 14rem;
$height: 7.5rem;

.word {
  width: $width;
  height: $height;
  @apply mx-4;
  @apply my-4;
}
</style>
